
export interface ITextStyleSelectable {
  isFontColorSelectable(): boolean;
  isPaintColorSelectable(): boolean;
}

export function instanceOfITextStyleSelectable(instance: any): instance is ITextStyleSelectable {
  return instance
      && instance.isFontColorSelectable
      && instance.isPaintColorSelectable;
}
